import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
// material
import { Box, Grid, Card, Button, Typography, Stack } from "@mui/material";
import { PATH_DASHBOARD } from "../../../routes/paths";
import { fDate } from "../../../utils/formatTime";
import { fCurrency, fNumber } from "../../../utils/formatNumber";
import { ShowError } from "../../../utils/loader";
import { CheckPerm } from "../../../utils/apis";
import { FulfillmentBadge } from "../orders";
// ----------------------------------------------------------------------

SingleCard.propTypes = {
  order: PropTypes.object,
};

function SingleCard({ order }) {
  const {
    products,
    subtotal,
    date,
    dateAdded,
    customerName,
    orderId,
    fulfillmentType,
    isPickup,
  } = order;
  let productsArray = [];
  try {
    productsArray =
      typeof products === "string" ? JSON.parse(products) : products || [];
  } catch (e) {
    productsArray = [];
  }
  const numProducts = productsArray.length;
  return (
    <Card
      variant="outlined"
      sx={{
        border: "0.4px solid",
        borderColor: "background.border",
        boxShadow:
          "4px 2px 124px rgba(46, 53, 58, 0.02), 0px 4px 124px rgba(46, 41, 78, 0.02)",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        p: 3,
      }}
    >
      <Box sx={{ flexGrow: 1, minWidth: 0, pl: 1, pr: 1 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1,
          }}
        >
          <Typography variant="subtitle2" noWrap sx={{ maxWidth: "60%" }}>
            #{orderId}
          </Typography>
          {(fulfillmentType || isPickup !== undefined) && (
            <FulfillmentBadge
              fulfillmentType={fulfillmentType}
              isPickup={isPickup}
              size="small"
            />
          )}
        </Box>
        <Typography variant="body2" noWrap sx={{ fontWeight: 600 }}>
          {fNumber(numProducts)} {(numProducts > 1 && "products") || "product"}{" "}
          to {customerName || "Walk-In Customer"}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", mt: 0.5 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            On {fDate(date || dateAdded)} <span>&nbsp;&nbsp;&middot;&nbsp;&nbsp;</span>{" "}
            {fCurrency(subtotal)}
          </Typography>
        </Box>
        {isPickup && (() => {
          let branchObj = order.pickupBranch;
          if (typeof branchObj === "string") {
            try {
              branchObj = JSON.parse(branchObj);
            } catch (e) {
              // keep as string
            }
          }
          const pickupName =
            (typeof branchObj === "string"
              ? branchObj
              : branchObj?.name ||
              branchObj?.branchName ||
              branchObj?.storeName ||
              branchObj?.title ||
              branchObj?.address) ||
            order.pickupBranchName ||
            order.branchName ||
            order.storeName ||
            order.store?.name ||
            order.storeDetails?.name ||
            order.pickupStore?.name ||
            order.fromAddress?.name;
          if (!pickupName) return null;
          return (
            <Typography
              variant="caption"
              sx={{ color: "text.secondary", display: "block", mt: 0.5 }}
              noWrap
            >
              📍 {pickupName}
            </Typography>
          );
        })()}
        <Button
          size="small"
          variant="outlined"
          color="primary"
          sx={{ mt: 2 }}
          component={RouterLink}
          to={`${PATH_DASHBOARD.ecommerce.orders}/${orderId}`}
        >
          View
        </Button>
      </Box>
    </Card>
  );
}

Orders.propTypes = {
  orders: PropTypes.array.isRequired,
  type: PropTypes.string,
};

export default function Orders({ orders, type }) {
  const hasPermission = CheckPerm("view_sales");
  return (
    <Box sx={{ mt: 5 }}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 3 }}
      >
        <Typography variant="h4">Orders</Typography>
        {hasPermission && (
          <Button
            size="small"
            variant="outlined"
            color="primary"
            component={RouterLink}
            to={PATH_DASHBOARD.ecommerce.orders}
          >
            View All
          </Button>
        )}
      </Stack>
      {orders.length > 0 ? (
        <Grid container spacing={3}>
          {orders.map((order, index) => (
            <Grid key={index} item xs={12} md={4}>
              <SingleCard order={order} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <ShowError
          message={new Error(`This ${type} has not been used at the moment!`)}
        />
      )}
    </Box>
  );
}
